// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4815) return "static/chunks/4815-37fdc49fe7e24dd4.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","8341":"b9b26c3f","9983":"profiler"}[chunkId] || chunkId) + "." + {"680":"95f34dc052d561cb","1767":"932b1a9d31bfdc8d","2377":"e13ffac37cfbdd0b","7382":"cd245c88a7064291","7415":"165f37a6a39a0b55","7538":"74629ae2be85ba8a","8341":"7efa0c1f5e817c75","9983":"26e8fdbd749e1a05"}[chunkId] + ".js";
};